<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Rules'|translate}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field  class="mr-4" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="uploadDialogSwitch = true" :disabled="!$can('update', 'Rule')"><v-icon small class="mr-2">fa-file-excel</v-icon> {{'Bulk Upload Excel'|translate}}</v-btn>
                    <v-btn class="accent" @click="exportPoints">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{'Download'|translate}}
                    </v-btn>

                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Rule')"><v-icon class="mr-2" small>fa-plus</v-icon> {{'Add Record'|translate}}</v-btn>
                    <rule-record-dialog v-model="dialog" :item="editedItem" :parameter="parameter" v-on:doreload="refresh()" v-on:refreshpoints="refreshpoints()"></rule-record-dialog>
                    <maintenance-upload-dialog
                            v-model="uploadDialogSwitch"
                            v-if="uploadDialogSwitch"
                            endpoint="/rule/upload/"
                            has-remove-switch
                            v-on:doreload="refresh()"
                            title="Rule Creation">
                    </maintenance-upload-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="rules"
                    class="elevation-1"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :items-per-page="25"
                    :search="search2"
            >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.desc }}</td>
        <td class="text-xs-left">{{ props.item.equipment_group }}</td>
        <td class="text-xs-left">

            <span v-if="props.item.on">{{'Equipment On'|translate}}</span>
            <span v-if="props.item.on===false">{{'Equipment Off'|translate}}</span>
            <span v-if="props.item.on===null">{{'Anytime'|translate}}</span>
        </td>
        <td class="text-xs-left">{{ props.item.topic }}</td>
        <td class="text-xs-left">
            <span v-if="!props.item.active_status||props.item.active_status=='active'">{{'Active'|translate}}</span>
            <span v-if="props.item.active_status=='inactive'">{{'Inactive'|translate}}</span>
            <span v-if="props.item.active_status=='muted'">{{'Muted'|translate}}</span>

        </td>
        <td class="text-xs-left">{{ props.item.rule }}</td>
        <td class="text-xs-left">{{ props.item.value }}</td>
        <td class="text-xs-left">{{ props.item.cost }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            v-if="$can('update', 'Rule')"
            @click="$can('update', 'Rule') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            v-if="$can('update', 'Rule')"
            @click="$can('update', 'Rule') &&  deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getRule, deleteRule, getParameter} from '../helper'
import RuleRecordDialog from '../components/rule/RuleRecordDialog'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import {exportCSV} from '../tocsv'

export default {
    name: 'Rules',
  components: { RuleRecordDialog,MaintenanceUploadDialog },
  data(){
    return{
      dialog: false,
        loading:true,
      uploadDialogSwitch: false,
      headers: [
        {
          text: this.$options.filters.translate('Title'),
          align: 'left',
          sortable: true,
          value: 'title'
        },{
          text: this.$options.filters.translate('Description'),
          align: 'left',
          sortable: true,
          value: 'desc'
        },
        { text: this.$options.filters.translate('Applicable Group(s)'), value: 'equipment_group' },
        { text: this.$options.filters.translate('Rule Active when'), value: 'on' },
        { text: this.$options.filters.translate('Topic'), value: 'topic', sortable: true },
        { text: this.$options.filters.translate('Active Status'), value: 'active_status', sortable: true },
        { text: this.$options.filters.translate('Rule'), value: 'rule', sortable: false },
        { text: this.$options.filters.translate('Value'), value: 'value', sortable: false},
        { text: this.$options.filters.translate('Cost'), value: 'cost', sortable: false },
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
      parameter:[],
      rules: [
        {
          desc: 'CHWS too cold',
          equipment_group: 'Chillers',
          'rule': 'df["CHWS_Temp"]<6',
          'on_only': true,
          'value': '1',
          'cost': '0'
        },
        {
          desc: 'CHWR too warm',
          equipment_group: 'Chillers',
          'rule': 'df["CHWR_Temp"]>20',
          'on_only': true,
          'value': '1',
          'cost': '0'
        },
        {
          desc: 'CHW Return Temp is Higher than CHW Supply',
          equipment_group: 'Chillers',
          'rule': 'df["CHWR_Temp"] - df["CHWS_Temp"]<0',
          'on_only': true,
          'value': '1',
          'cost': '0'
        }

      ],
      editedIndex: -1,
      editedItem: {
      },
      search: '',
      search2: ''
    }},
  watch: {
      search(){
        this.debounce(this.syncSearches,500);
      }
  },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.rules.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.rules.indexOf(item)
        if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?')) ){
          this.rules.splice(index, 1)
          await deleteRule({
            'rule_id': item.rule_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rules[this.editedIndex], this.editedItem)
        } else {
          this.rules.push(this.editedItem)
        }
        this.close()
      },
        async refreshpoints(){
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.parameter = dfp['result']
        },
        async refresh() {
            this.loading=true
            let df = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.rules = df['result']
            this.parameter = dfp['result']
            this.loading=false
            this.dialog=false
        },
        syncSearches(){
          this.search2=this.search
        },
        debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
        },
        exportPoints() {
            let cleanedItems=JSON.parse(JSON.stringify(this.rules))
            exportCSV(cleanedItems.map(item=>{return {
                desc:item.desc,
                equipment_group:item.equipment_group,
                rule:item.rule,
                on:item.on,
                value:item.value,
                cost:item.cost,
                severity:item.severity,
                title:item.title,
                relevant_variables:item.relevant_variables,
                recommended_actions:item.recommended_actions,
                topic:item.topic,
                active_status:item.active_status,
            }}))
        },
    }
  }
</script>

<style scoped>

</style>
